 
import { Inject, Injectable, Renderer2, RendererFactory2 } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { FeatureFlagsService } from '@services/feature-flags.service';
import { DOCUMENT } from '@angular/common';

@Injectable()
export class InlineManualService {
  private renderer: Renderer2;
  constructor(
    private http: HttpClient,
    private featureFlagsService: FeatureFlagsService,
    private rendererFactory: RendererFactory2,
    @Inject(DOCUMENT) private document: Document
  ) {
    this.renderer = this.rendererFactory.createRenderer(null, null);
  }

  private inlineManualConfig() {
    try {
      const userInfo = JSON.parse(localStorage.getItem('user_info'));
      (window as any).inlineManualTracking = {
        uid: userInfo.rid,
        email: userInfo.email,
        name: userInfo.firstname
      };
    } catch (error) {}
  }

  private inlineManualInit() {
    let identifier = window.location.host.split('.')[0];
    if (identifier.includes('localhost')) {
      identifier = 'dev';
    }

    const apiEndpoint = `/api/v1/team/token/${identifier}`;
    const url = apiEndpoint;

    this.http.get<{ token: string }>(url).subscribe((response) => {
      const inlineURL = `https://inlinemanual.com/embed/player.${response.token}.js`;

      try {
        const script = this.renderer.createElement('script');
        script.src = inlineURL;
        script.type = 'text/javascript';
        script.async = false;
        script.charset = 'utf-8';

        this.renderer.appendChild(this.document.head, script);
      } catch (e) {}
    });
  }

  openInlineconfig() {
    if (this.featureFlagsService.isTutorialEnabled) {
      this.inlineManualConfig();
      (window as any).inlineManualConfig = this.inlineManualConfig;
    }
  }

  openInlineManualInit() {
    if (this.featureFlagsService.isTutorialEnabled) {
      this.inlineManualInit();
      (window as any).inlineManualInit = this.inlineManualInit;
    }
  }
}
